import { render, staticRenderFns } from "./EmailDocument.vue?vue&type=template&id=2a77479e&scoped=true&"
import script from "./EmailDocument.vue?vue&type=script&lang=js&"
export * from "./EmailDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a77479e",
  null
  
)

export default component.exports